import { TaskQueueDetail } from 'common/types';
import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';

const taskQueue = {
  getListBackground: (params?: { versionId?: string }): ExtendAxioResponse<TaskQueueDetail[]> => {
    const otherParams = getNormalParams('listBackgroundVersion');
    return FastApiAxiosInstance.get('/api/v1/version/listBackgroundVersion', { params: { ...params, ...otherParams } });
  },
  deleteBackgroundVersion: (params?: { versionId?: string }): ExtendAxioResponse => {
    return FastApiAxiosInstance.post('/api/v1/version/deleteBackgroundVersion', params);
  },
};
export default taskQueue;
